module.exports = __webpack_public_path__ + "static/img/public.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/public.png
// module id = HVzY
// module chunks = 21